// This script loads dependencies first, then loads the build.
import { outputPath } from './outputPath';

const dds =
  'https://uat.mckinsey.com/spContent/dds/dds-pattern-library/staging/css/style.css';
// Dynamically load dds pattern library CSS.
// See https://github.com/McK-Internal/ext-dds-pattern-library
const loadCSS = (url) =>
  new Promise((resolve) => {
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = url;
    link.onload = () => {
      resolve();
    };
    document.head.appendChild(link);
  });

const loadScript = (url) =>
  new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = () => {
      resolve();
    };
    document.head.appendChild(script);
  });

// Constructs the src attribute of a <script> tag
// that pulls in multiple libraries from JSDelivr
// with only a single network request.
// See https://www.jsdelivr.com/features#combine
const jsDelivrCombine = (libs) =>
  'https://cdn.jsdelivr.net/combine/' +
  libs.map((lib) => `npm/${lib}`).join(',');

const reactVersion = '18.1.0';
const d3Version = '7.3.0';
const libraries = jsDelivrCombine([
  `react@${reactVersion}/umd/react.production.min.js`,
  `react-dom@${reactVersion}/umd/react-dom.production.min.js`,
  `d3@${d3Version}/dist/d3.min.js`,
]);

// Load the CSS and JS libraries in parallel.
// After they are loaded, load our JS build that depends on them.
const main = async () => {
  await Promise.all([
    loadScript(libraries),
    // loadCSS(dds),
    loadCSS(outputPath + 'styles.css'),
  ]);
  // loadScript('/spContent/bespoke/ria/main.js');
  loadScript(outputPath + 'main.js');
};

main();

// Dynamically load dds pattern library JS.
// See https://github.com/McK-Internal/ext-dds-pattern-library
// TODO bring this back when it becomes clear that it is required.
// What does it even do?
// const script = document.createElement('script');
// script.src = 'https://uat.mckinsey.com/spContent/dds/dds-pattern-library/js/script-min.js';
// document.head.appendChild(script);
// script.onload = () => {
//     console.log('Loaded dds-pattern-library JS');
// }
